import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const WINNING_COMBINATIONS = [
  [0, 1, 2], [3, 4, 5], [6, 7, 8], // Rows
  [0, 3, 6], [1, 4, 7], [2, 5, 8], // Columns
  [0, 4, 8], [2, 4, 6]             // Diagonals
];

export default function TicTacToe() {
  const [board, setBoard] = useState(Array(9).fill(null));
  const [isXNext, setIsXNext] = useState(true);

  const calculateWinner = (squares) => {
    for (let i = 0; i < WINNING_COMBINATIONS.length; i++) {
      const [a, b, c] = WINNING_COMBINATIONS[i];
      if (squares[a] && squares[a] === squares[b] && squares[a] === squares[c]) {
        return { winner: squares[a], line: [a, b, c] };
      }
    }
    if (squares.every((sq) => sq !== null)) {
      return { winner: 'Draw', line: [] };
    }
    return null;
  };

  const winInfo = calculateWinner(board);
  const winner = winInfo ? winInfo.winner : null;
  const winningLine = winInfo ? winInfo.line : [];

  const handleClick = (index) => {
    if (board[index] || winner) return;

    const newBoard = [...board];
    newBoard[index] = isXNext ? 'X' : 'O';
    setBoard(newBoard);
    setIsXNext(!isXNext);
  };

  const restartGame = () => {
    setBoard(Array(9).fill(null));
    setIsXNext(true);
  };

  let statusText = '';
  if (winner === 'Draw') {
    statusText = "It's a Draw!";
  } else if (winner) {
    statusText = `Winner: Player ${winner}! 🎉`;
  } else {
    statusText = `Player ${isXNext ? 'X' : 'O'}'s Turn`;
  }

  return (
    <main className="bg-gray-50 py-16 min-h-[calc(100vh-130px)]">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mb-6">
          <Link to="/projects" className="text-indigo-600 hover:text-indigo-800 font-semibold flex items-center gap-1">
            &larr; Back to Projects
          </Link>
        </div>

        <div className="flex flex-col items-center">
          <h1 className="text-4xl font-bold text-gray-900 mb-2">Tic-Tac-Toe</h1>
          <p className="text-lg font-semibold text-gray-700 mb-6 bg-white px-6 py-2 rounded-full shadow-sm border border-gray-200">
            {statusText}
          </p>

          {/* 3x3 Game Board */}
          <div className="grid grid-cols-3 gap-2 bg-gray-300 p-3 rounded-xl shadow-lg">
            {board.map((value, idx) => {
              const isWinningSquare = winningLine.includes(idx);
              return (
                <button
                  key={idx}
                  onClick={() => handleClick(idx)}
                  className={`w-24 h-24 md:w-32 md:h-32 rounded-lg flex items-center justify-center text-5xl md:text-6xl font-bold transition-all duration-200 focus:outline-none ${
                    isWinningSquare
                      ? 'bg-green-100 ring-4 ring-green-500 scale-105 shadow-md'
                      : 'bg-white hover:bg-gray-100'
                  }`}
                >
                  {value === 'X' && <span className="text-blue-500">X</span>}
                  {value === 'O' && <span className="text-red-500">O</span>}
                </button>
              );
            })}
          </div>

          <button
            onClick={restartGame}
            className="mt-8 bg-indigo-600 text-white font-semibold py-2.5 px-8 rounded-lg shadow-md hover:bg-indigo-700 active:scale-95 transition-all duration-200"
          >
            Restart Game
          </button>
        </div>
      </div>
    </main>
  );
}
